import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_Variables = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      title="Variables"
      videos={[
        "https://www.youtube.com/embed/-K0KD0UdKpQ", // Constants in C Programming
        "https://www.youtube.com/embed/aIQk1O08zpg", // C Variables
      ]}
      takeaways={[
        { text: "Remember the definition of a variable and rules of naming variables and constants." },
        { text: "For each answer, make sure to include examples." },
      ]}
      questions={[
        "They may give some variables and ask whether they are in the correct format or not (this is a basic-level question).",
        "What are the different types of constants?",
        "What is the difference between variables and constants?",
      ]}
      exampleVideos={[]} // No example videos
      subtopics={subtopics}
      subjectPath={subjectPath}
    />
  );
};

export default OOPS_M1_Variables;



